import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { GroupCategory } from "../../types";
import { useTranslation } from "react-i18next";

export interface Props {
  categories: GroupCategory[];
  selected?: GroupCategory;
  onChange: (groupcategory: GroupCategory | undefined) => void;
}

export const GroupCategorySelector = ({
  categories,
  selected,
  onChange,
}: Props) => {
  const [t] = useTranslation();
  return (
    <FormControl size="small" fullWidth>
      <Select
        labelId="category-select-label"
        id="category-select"
        value={selected ? selected.id : "all"}
        onChange={(e) => {
          const target =
            e.target.value === "all"
              ? undefined
              : categories.find((target) => target.id == e.target.value);
          onChange(target);
        }}
      >
        <MenuItem value={"all"}>All Group Categories</MenuItem>
        {categories.map((category, index) => (
          <MenuItem key={index} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
